import React from "react";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import ContentCopy from "@mui/icons-material/ContentCopy";
import OpenInNewOutlined from "@mui/icons-material/OpenInNewOutlined";
import { enqueueSnackbar } from "notistack";
import { useCopyToClipboard } from "usehooks-ts";
import { SectionHeading } from "../core/font-sizes";
import { useGameSellsheets } from "@seabrookstudios/pitch2table";
import { useGameIdFromRoute } from "../games/WithGameIdFromRoute";
import { ImageOrPdfViewer } from "../core/ImageOrPdfViewer";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").Url?} [props.url]
 * @returns {React.JSX.Element}
 */
export const PublicSellsheet = ({ url }) => {
  const [, copy] = useCopyToClipboard();
  const gameId = useGameIdFromRoute();
  const { data: sellsheets } = useGameSellsheets(gameId);
  const data = sellsheets && sellsheets.length > 0 ? sellsheets[0] : null;

  const copyUrlToClipboard = () => {
    if (!url) {
      return;
    }

    copy(url);
    enqueueSnackbar("Url copied to clipboard", { variant: "info" });
  };

  if (!data || data.length === 0) {
    return (
      <ListItem>
        <ListItemText primary="Sellsheets" secondary="Not available" />
      </ListItem>
    );
  }

  return (
    <Stack direction="column">
      <Stack p={2} pb={0} direction="row" display="flex" justifyContent="space-between">
        <SectionHeading>Sellsheet</SectionHeading>
        {url && (
          <Box>
            <ListItemIcon>
              <ListItemButton onClick={copyUrlToClipboard}>
                <ContentCopy />
              </ListItemButton>
            </ListItemIcon>
            <a href={url} target="_blank" rel="noreferrer">
              <ListItemIcon>
                <ListItemButton>
                  <OpenInNewOutlined />
                </ListItemButton>
              </ListItemIcon>
            </a>
          </Box>
        )}
      </Stack>
      <ImageOrPdfViewer document={data[0]} />
    </Stack>
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").Url?} [props.url]
 * @returns {React.JSX.Element}
 */
export const PublisherSellsheet = ({ url }) => {
  const [, copy] = useCopyToClipboard();
  const gameId = useGameIdFromRoute();
  const { data: sellsheets } = useGameSellsheets(gameId);
  const data = sellsheets && sellsheets.length > 0 ? sellsheets[0] : null;

  const copyUrlToClipboard = () => {
    if (!url) {
      return;
    }

    copy(url);
    enqueueSnackbar("Url copied to clipboard", { variant: "info" });
  };

  if (!data || data.length === 0) {
    return (
      <ListItem>
        <ListItemText primary="Sellsheets" secondary={"Not available"} />
      </ListItem>
    );
  }

  return (
    <Stack direction="column">
      <Stack p={2} pb={0} direction="row" display="flex" justifyContent="space-between">
        <ListItemText primary="Sellsheet" secondary="" />
        {url && (
          <Box>
            <ListItemIcon>
              <ListItemButton onClick={copyUrlToClipboard}>
                <ContentCopy />
              </ListItemButton>
            </ListItemIcon>
            <a href={url} target="_blank" rel="noreferrer">
              <ListItemIcon>
                <ListItemButton>
                  <OpenInNewOutlined />
                </ListItemButton>
              </ListItemIcon>
            </a>
          </Box>
        )}
      </Stack>
      <ImageOrPdfViewer document={data[0]} />
    </Stack>
  );
};
